import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MotionConfig } from 'motion/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import CookieConsent from './components/CookieConsent'
import i18n from './i18n'
import { getPathLang, langBasename } from './lib/lang'
import { registerWebMcpTools } from './lib/webmcp'
import './index.css'

// Jazyk MUSÍ odpovídat URL: prefix (/en, /de…) → daný jazyk; BEZ prefixu = čeština.
// Bez fallbacku na 'cs' by se na kořeni / vzal jazyk prohlížeče (detektor navigator) a
// Seznambot/cizí prohlížeč by dostal anglický obsah → Seznam hlásí „stránka není v češtině".
const pathLang = getPathLang() || 'cs'
if (i18n.language !== pathLang) i18n.changeLanguage(pathLang)

// <html lang="…"> + content-language drž synchronně s aktivním jazykem (přístupnost + SEO).
const applyHtmlLang = (lng: string) => {
  document.documentElement.lang = lng
  let meta = document.querySelector('meta[http-equiv="content-language"]') as HTMLMetaElement | null
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('http-equiv', 'content-language')
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', lng)
}
applyHtmlLang(pathLang)
i18n.on('languageChanged', applyHtmlLang)

// WebMCP — zpřístupní naše akce AI agentům v prohlížeči (no-op tam, kde API není).
registerWebMcpTools()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={langBasename()}>
          {/* reducedMotion="user" → Framer Motion respektuje OS „omezit pohyb" (WCAG) */}
          <MotionConfig reducedMotion="user">
            <App />
            <CookieConsent />
          </MotionConfig>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
